import React, { useState } from 'react';
import { Link2 } from 'lucide-react';

const LINK_VERDICT_COLOR = {
  verified:   'var(--color-verified)',
  disputed:   'var(--color-disputed)',
  invalidated:'var(--color-invalidated)',
};

export default function LinkPreview({ meta, url, linkVerdict }) {
  const [imgFailed, setImgFailed] = useState(false);

  if (!url) return null;

  let domain = '';
  try { domain = new URL(url).hostname.replace(/^www\./, ''); } catch (_) {}

  const hasImage = meta?.og_image && !imgFailed;
  const hasTitle = meta?.og_title;
  const hasDesc  = meta?.og_description;
  const hasAny   = meta?.og_image || hasTitle || hasDesc; // use raw og_image for 'no meta' test

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={e => e.stopPropagation()}
      style={{
        display: 'block',
        marginTop: 12,
        border: '1px solid var(--color-border)',
        borderRadius: 10,
        overflow: 'hidden',
        textDecoration: 'none',
        background: 'var(--color-surface)',
        transition: 'border-color 0.15s ease',
      }}
      onMouseEnter={e => (e.currentTarget.style.borderColor = 'var(--color-border-strong)')}
      onMouseLeave={e => (e.currentTarget.style.borderColor = 'var(--color-border)')}
    >
      {/* Image area — show og_image if available; placeholder if image load fails */}
      {meta?.og_image && (
        hasImage ? (
          <img
            src={meta.og_image}
            alt=""
            style={{ width: '100%', maxHeight: 180, objectFit: 'cover', display: 'block' }}
            onError={() => setImgFailed(true)}
          />
        ) : (
          /* Image failed to load — show generic link icon placeholder */
          <div style={{
            width: '100%', height: 72,
            background: 'var(--color-bg)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            borderBottom: '1px solid var(--color-border)',
          }}>
            <Link2 size={24} color="var(--color-text-muted)" strokeWidth={1.5} />
          </div>
        )
      )}
      <div style={{ padding: '10px 14px' }}>
        {domain && (
          <p style={{
            fontSize: 11,
            color: 'var(--color-text-muted)',
            marginBottom: 4,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            fontFamily: 'var(--font-body)',
          }}>
            {domain}
          </p>
        )}
        {hasTitle && (
          <p style={{
            fontFamily: 'var(--font-body)',
            fontWeight: 600,
            fontSize: 15,
            color: 'var(--color-text-primary)',
            marginBottom: hasDesc ? 4 : 0,
            lineHeight: 1.4,
          }}>
            {meta.og_title}
          </p>
        )}
        {hasDesc && (
          <p style={{
            fontFamily: 'var(--font-body)',
            fontSize: 13,
            color: 'var(--color-text-secondary)',
            margin: 0,
            lineHeight: 1.5,
          }}>
            {meta.og_description.length > 120
              ? meta.og_description.slice(0, 118) + '…'
              : meta.og_description}
          </p>
        )}
        {!hasAny && (
          <p style={{ fontFamily: 'var(--font-body)', fontSize: 13, color: 'var(--color-text-muted)', margin: 0, wordBreak: 'break-all' }}>
            {url.length > 80 ? url.slice(0, 78) + '…' : url}
          </p>
        )}
      </div>
      {linkVerdict && LINK_VERDICT_COLOR[linkVerdict] && (
        <div style={{
          height: 4,
          background: LINK_VERDICT_COLOR[linkVerdict],
          width: '100%',
        }} />
      )}
    </a>
  );
}
